import { setDependentAnswerPreset, setDirectAnswerPreset } from "../..";
import { GLOBAL_PRESETS } from "../presets";
import { TAnswerFlow } from "../types";
import * as beautyUtils from "../utils";

export const COLORSONIC_ANSWER_FLOWS: Record<number, TAnswerFlow> = {
  0: setDirectAnswerPreset(
    undefined,
    "Colorsonic Inline - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock for the Colorsonic Inline POG",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].colorsonic.before()
  ),
  1: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of L'Oreal Colorsonic items you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].colorsonic.total_stocked()
  ),
  2: setDependentAnswerPreset(
    undefined,
    "L'Oreal Colorsonic: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [0],
    beautyUtils.getAfterOOSCount
  ),
  3: setDependentAnswerPreset(
    undefined,
    "L'Oreal Colorsonic: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [2],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  4: setDependentAnswerPreset(
    undefined,
    "Select why 0 Items needed a count correction",
    "radio",
    [3],
    beautyUtils.getWhyZeroItemsNeededCountCorrection
  ),
};
